import HomeComponent from "../../home/home";
import { connected as AppComponent } from "../../app";
import { connected as PoisComponent } from "../../pois/components/pois";
import { connected as ListComponent } from "../../list/components/list";
import constants from "../../../../server/lib/constants";
// import {
//   RESOURCE_MAP,
//   RESOURCE_KIND_MAP,
// } from "../../../../server/routes/constants";

const childRoutes = [
  {
    path: "/",
    component: HomeComponent,
  },
  {
    path: `/(**/)${constants.AJAX_PATH}/:resource-:kind/:placeId`,
    component: ListComponent,
  },
  {
    path: `/(**/)${constants.AJAX_PATH}/:resource/:placeId`,
    component: ListComponent,
  },
  {
    path: `/(**/)${constants.AJAX_PATH}/:resource-:kind/:id/:placeId`,
    component: PoisComponent,
  },
  {
    path: `/(**/)${constants.AJAX_PATH}/:resource/:id/:placeId`,
    component: PoisComponent,
  },
];

const routes = {
  path: "",
  component: AppComponent,
  childRoutes,
};

export default routes;



// WEBPACK FOOTER //
// ./assets/shared/routes/index.js